var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-of-products",class:{
    'grid-of-products--full-images': _vm.block.renderAs === 'full-images',
  },style:({
    '--number-of-lines': _vm.numberOfLines.mobile,
    '--number-of-lines-desktop': _vm.numberOfLines.desktop,
  })},_vm._l((_vm.links),function(link,index){return _c(_vm.cardComponent(link),_vm._b({key:link._key,tag:"component",attrs:{"from-line-of-links":""}},'component',_vm.cardAttributes(link, index),false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }